import _extends from "@babel/runtime/helpers/esm/extends";
import { css as _css } from "@emotion/react";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import clsx from 'clsx';
import { useTheme } from '@emotion/react';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const StylesSectionTitleWrapper = (theme, props) => {
  // Translate "align" prop to work with `justifyItems`
  const getJustify = align => {
    if (align === 'left') return 'start';
    if (align === 'right') return 'end';
    return align;
  };

  return [props.space === 'xlarge' && {
    marginBottom: theme.space.large,
    [theme.mq.medium]: {
      marginBottom: theme.space.xlarge
    }
  }, props.space === 'large' && {
    marginBottom: theme.space.medium,
    [theme.mq.medium]: {
      marginBottom: theme.space.large
    }
  }, {
    display: 'grid',
    justifyItems: 'center',
    textAlign: 'center'
  }, props.align.base && props.align.base !== 'center' && {
    textAlign: props.align.base,
    justifyItems: getJustify(props.align.base)
  }, props.align.small && {
    [theme.mq.small]: {
      textAlign: props.align.small,
      justifyItems: getJustify(props.align.small)
    }
  }, props.align.medium && {
    [theme.mq.medium]: {
      textAlign: props.align.medium,
      justifyItems: getJustify(props.align.medium)
    }
  }, props.align.large && {
    [theme.mq.large]: {
      textAlign: props.align.large,
      justifyItems: getJustify(props.align.large)
    }
  }, props.align.xlarge && {
    [theme.mq.xlarge]: {
      textAlign: props.align.xlarge,
      justifyItems: getJustify(props.align.xlarge)
    }
  }];
};
export const StylesSectionTitleSub = theme => [_objectSpread(_objectSpread({
  color: theme.fontColor.base
}, theme.text.medium), {}, {
  maxWidth: 750,
  '.u-contrast &': {
    color: theme.contrast.base
  }
})];

const SectionTitle = _ref => {
  let {
    align = {
      base: 'center'
    },
    as: Component = 'h3',
    children,
    className,
    space = 'xlarge',
    sub,
    subProps,
    title,
    titleProps
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["align", "as", "children", "className", "space", "sub", "subProps", "title", "titleProps"]);

  const theme = useTheme();
  return ___EmotionJSX("div", _extends({
    className: clsx(`CK__SectionTitle ${theme.settings.classes.trim}`, className),
    css: StylesSectionTitleWrapper(theme, {
      space,
      align
    })
  }, rest), ___EmotionJSX(Component, _extends({
    css: /*#__PURE__*/_css({
      marginBottom: theme.space.small,
      [theme.mq.medium]: {
        marginBottom: theme.space.base
      }
    }, process.env.NODE_ENV === "production" ? "" : ";label:SectionTitle;"),
    className: "CK__SectionTitle__Header"
  }, titleProps), title), sub && ___EmotionJSX("div", _extends({
    className: "CK__SectionTitle__Sub",
    css: StylesSectionTitleSub(theme)
  }, subProps), sub), children);
};

export default SectionTitle;